import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import Boots from "./images/boots.png";
import TumbleDryer from "./images/tumble_dryer_icon.png";
import PetsIcon from "@mui/icons-material/Pets";
import WashingMachine from "./images/washingMachine.png";
import HardHat from "./images/hard-hat.png";
import './styles/Pricing.scss';

const PricingSection = () => {
  return (
    <section className="home__pricing" id="prices">
      <div className="home_pricing_content">
        <h2>Convenience at <span>affordable pricing</span></h2>
        
        <Swiper
          modules={[Autoplay, Pagination]}
          spaceBetween={35}
          slidesPerView={1}
          centeredSlides={true}
          pagination={{ clickable: true }}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false
          }}
          breakpoints={{
            691: {
              slidesPerView: 3,
              centeredSlides: false,
              spaceBetween: 40,
              autoplay: false
            }
          }}
          className="pricing-swiper"
        >
          <SwiperSlide>
            <div className="pricing_card">
              <img src={WashingMachine} className="img_icon" alt="washing machine" />
              <h2>Wash</h2>
              <div className="card__text">
                <strong>SMALL (Approx 8kg) <span>- £5.50</span></strong>
                <strong>MEDIUM (Approx 14KG) <span>- £9.00</span></strong>
                <strong>LARGE (Approx 18KG) <span>- £11.00</span></strong>
              </div>
              <div className="line_big"></div>
              <div className="line_small"></div>
              <em>All our machines are <strong>100%</strong> sanitised after each wash.</em>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="pricing_card">
              <img src={TumbleDryer} className="img_icon" alt="tumble dryer" />
              <h2>Dry</h2>
              <div className="card__text" style={{marginBottom:'90px'}}>
                <strong>Every 15 mins <span>- £3.50</span></strong>
              </div>
              <div className="line_big"></div>
              <div className="line_small"></div>
              <em>
                For <strong>best results</strong>, do not overload the machine,
                plus you can open the machine at any time to check if the
                laundry is dry.
              </em>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="pricing_card">
              <div className="multi_icons">
                <PetsIcon className="card_icon" />
                <img src={HardHat} className="img_icon" alt="hard hat" />
                <img src={Boots} className="img_icon" alt="boots" />
              </div>
              <h2>Heavy Duty</h2>
              <div className="card__text">
                <strong>MEDIUM (Approx 14KG) <span>- £9.00</span></strong>
                <strong>Heavy duty dry every 15 mins <span>- £3.50</span></strong>
              </div>
              <div className="line_big"></div>
              <div className="line_small"></div>
              <em>
                Specialised machines dedicated to{" "}
                <strong>heavy duty cleaning</strong> of your larger laundry
                items.
              </em>
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
    </section>
  );
};

export default PricingSection;